/**
 * Copyright Mántum All Rights Reserved.
 */
import Loading from './loading';

export type PropTypes = {
    children?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    loading?: boolean;
    onClick?: () => void;
    testid?: string;
    title?: string;
    truncate?: boolean;
    type?: 'fat' | 'simple';
};

export default function Button(props: PropTypes) {
    // prettier-ignore
    const {
        disabled = false,
        loading = false,
        truncate = false,
        type = 'simple'
    } = props

    const className = truncate ? ' truncate' : '';

    const style = type === 'fat' ? ' h-14 text-lg' : '';

    return (
        <button
            className={`${props.className}${className}${style}`}
            data-testid={props.testid}
            disabled={disabled}
            onClick={props.onClick}
            title={props.title}
            type='button'
        >
            {loading && <Loading />}
            {props.children}
        </button>
    );
}
